import api, { getBaseURL } from "@/api/client";
import authApi from "@/api/auth.api";
import frequencyApi from "@/api/frequency.api";
import fleetApi from "@/api/fleet.api";
import gtfsApi from "@/api/gtfs.api";
import routeApi from "@/api/route.api";
import competitionApi from "@/api/competition.api";
import { logger } from "@/utils/logger";
const appApi = {
    get(url, config) {
        return api.get(url, config);
    },
    post(url, data, config) {
        return api.post(url, data, config);
    },
    put(url, data, config) {
        return api.put(url, data, config);
    },
    delete(url, config) {
        return api.delete(url, config);
    },
    download(path) {
        return api.get("/download", {
            params: { path },
            responseType: "blob",
        });
    },
    runGorevAtama(payload) {
        return api.post("/gorev-atama/run", payload).then((res) => {
            const data = res.data || {};
            if (data.sonuclar && data.sonuclar.sofor_istatistikleri) {
                const soforSayisi = Object.keys(data.sonuclar.sofor_istatistikleri).length;
                logger.debug(`✓ Şoför istatistikleri alındı: ${soforSayisi} şoför`);
                const ilkSoforler = Object.values(data.sonuclar.sofor_istatistikleri).slice(0, 3);
                ilkSoforler.forEach((sofor, index) => {
                    logger.debug(`Şoför ${index + 1}: ${sofor.sofor_adi} - ${sofor.toplam_mesai_saat}h (${sofor.mesai_durumu})`);
                });
            }
            else {
                console.warn("⚠ Şoför istatistikleri bulunamadı");
            }
            if (data.sonuclar && data.sonuclar.genel_istatistikler) {
                logger.debug("✓ Genel istatistikler alındı:", {
                    "Toplam şoför": data.sonuclar.genel_istatistikler.toplam_sofor,
                    "Toplam araç": data.sonuclar.genel_istatistikler.toplam_arac,
                    "Toplam mesai (saat)": data.sonuclar.genel_istatistikler.toplam_mesai_saat,
                    "Ortalama şoför mesai": data.sonuclar.genel_istatistikler.ortalama_sofor_mesai,
                });
            }
            else {
                console.warn("⚠ Genel istatistikler bulunamadı");
            }
            return data;
        });
    },
    getGorevAtamaOzet() {
        return api.get("/gorev-atama/ozet").then((res) => res.data);
    },
    getGorevAtamaPlanDurumu(senaryoId) {
        return api
            .get("/gorev-atama/plan-durumu", { params: { senaryo_id: senaryoId } })
            .then((res) => res.data);
    },
    getMesaiIhlalleri() {
        return api.get("/gorev-atama/mesai-ihlalleri").then((res) => res.data);
    },
    getVardiyaDegisimleri() {
        return api.get("/gorev-atama/vardiya-degisimleri").then((res) => res.data);
    },
    getGorevAtamaConfig() {
        return api.get("/gorev-atama/config").then((res) => res.data);
    },
    setGorevAtamaConfig(params) {
        const payload = { params };
        return api.post("/gorev-atama/config", payload).then((res) => res.data);
    },
    saveGorevAtamaSonucu(payload) {
        return api.post("/gorev-atama/kaydet-sonuc", payload).then((res) => res.data);
    },
    getDonemler(durum) {
        const params = durum ? { durum } : {};
        return api.get("/donemler/", { params }).then((res) => res.data);
    },
    createDonem(data) {
        return api.post("/donemler/", data).then((res) => res.data);
    },
    updateDonem(donemId, data) {
        return api.put(`/donemler/${donemId}`, data).then((res) => res.data);
    },
    deleteDonem(donemId) {
        return api.delete(`/donemler/${donemId}`).then((res) => res.data);
    },
    donemAktifYap(donemId) {
        return api.post(`/donemler/${donemId}/aktif`).then((res) => res.data);
    },
    getSenaryolar(donemId) {
        const params = donemId ? { donem_id: donemId } : {};
        return api.get("/senaryolar/", { params }).then((res) => res.data);
    },
    createSenaryo(data) {
        return api.post("/senaryolar/", data).then((res) => res.data);
    },
    getSenaryoDetay(senaryoId, opts = {}) {
        const params = {};
        if (opts.gun_tipi != null && opts.gun_tipi !== "") {
            params.gun_tipi = opts.gun_tipi;
        }
        return api.get(`/senaryolar/${senaryoId}`, { params }).then((res) => res.data);
    },
    updateSenaryo(senaryoId, data) {
        return api.put(`/senaryolar/${senaryoId}`, data).then((res) => res.data);
    },
    deleteSenaryo(senaryoId) {
        return api.delete(`/senaryolar/${senaryoId}`).then((res) => res.data);
    },
    temizleSenaryoVeri(senaryoId, data = {}) {
        return api.post(`/senaryolar/${senaryoId}/veri-temizle`, data).then((res) => res.data);
    },
    kopyalaSenaryo(senaryoId, data) {
        return api.post(`/senaryolar/${senaryoId}/kopyala`, data).then((res) => res.data);
    },
    getSenaryoKarsilastir(ids, gunTipi) {
        const idsParam = Array.isArray(ids) ? ids.join(",") : ids;
        const params = { ids: idsParam };
        if (gunTipi != null && gunTipi !== "") {
            params.gun_tipi = gunTipi;
        }
        return api.get("/senaryolar/karsilastir", { params }).then((res) => res.data);
    },
    getGlobalSettings() {
        return api.get("/global-settings/").then((res) => res.data);
    },
    updateGlobalSettings(data) {
        return api.put("/global-settings/", data).then((res) => res.data);
    },
    getPipelineSettings() {
        return api.get("/admin/pipeline-settings/").then((res) => res.data);
    },
    putPipelineSettings(body) {
        return api.put("/admin/pipeline-settings/", body).then((res) => res.data);
    },
    getPipelineCronSyncStatus() {
        return api.get("/admin/pipeline-settings/cron-sync-status").then((res) => res.data);
    },
    postPipelineRetentionPreview() {
        return api.post("/admin/pipeline-retention/preview", {}).then((res) => res.data);
    },
    postPipelineRetentionApply() {
        return api
            .post("/admin/pipeline-retention/run", { apply: true }, { params: { apply: "true" } })
            .then((res) => res.data);
    },
    postPipelineAlightingTrigger(body) {
        return api
            .post("/admin/pipeline-alighting/trigger", body, {
            validateStatus: (status) => (status >= 200 && status < 300) || status === 202 || status === 409,
        })
            .then((res) => res);
    },
    getPipelineAlightingTempExtractCount(reportDate) {
        return api
            .get("/admin/pipeline-alighting/temp-extract-count", {
            params: { report_date: reportDate },
        })
            .then((res) => res.data);
    },
    getPipelineAlightingContext() {
        return api.get("/admin/pipeline-alighting/context").then((res) => res.data);
    },
    getPipelineRuns(params) {
        return api.get("/admin/pipeline-runs", { params }).then((res) => res.data);
    },
    getPipelineRun(runId) {
        return api.get(`/admin/pipeline-runs/${runId}`).then((res) => res.data);
    },
    postPipelineIngestCsv(reportDate, file, idempotencyKey) {
        const fd = new FormData();
        fd.append("report_date", reportDate);
        fd.append("file", file);
        const headers = {};
        if (idempotencyKey) {
            fd.append("idempotency_key", idempotencyKey);
            headers["X-Idempotency-Key"] = idempotencyKey;
        }
        return api
            .post("/admin/pipeline-ingest/csv", fd, {
            headers: { "Content-Type": "multipart/form-data", ...headers },
        })
            .then((res) => res.data);
    },
    postPipelineIngestBatch(body) {
        return api.post("/admin/pipeline-ingest/batch", body).then((res) => res.data);
    },
    postPipelineIngestCommit(ingestRunId, batchSize) {
        const payload = { ingest_run_id: ingestRunId };
        if (batchSize != null &&
            batchSize !== "" &&
            Number.isFinite(Number(batchSize))) {
            const n = Number(batchSize);
            if (n >= 1000 && n <= 5000) {
                payload.batch_size = n;
            }
        }
        return api.post("/admin/pipeline-ingest/commit", payload).then((res) => res.data);
    },
    fetchPipelineIngestErrorsCsv(ingestRunId) {
        return api.get(`/admin/pipeline-ingest/runs/${ingestRunId}/errors.csv`, {
            responseType: "blob",
            validateStatus: () => true,
        });
    },
    getPipelineIngestErrorsCsvUrl(ingestRunId) {
        const base = getBaseURL().replace(/\/+$/, "");
        return `${base}/admin/pipeline-ingest/runs/${ingestRunId}/errors.csv`;
    },
    analyze: frequencyApi.analyze,
    loadPlan: frequencyApi.loadPlan,
    savePlan: frequencyApi.savePlan,
    exportToDatabase: frequencyApi.exportToDatabase,
    topluFrekansOptimizasyon: frequencyApi.topluFrekansOptimizasyon,
    getHatList: frequencyApi.getHatList,
    getSqlHatList: frequencyApi.getSqlHatList,
    getHatDuraklari: frequencyApi.getHatDuraklari,
    getPlanList: frequencyApi.getPlanList,
    getPlanDetail: frequencyApi.getPlanDetail,
    listFrekansHatPresets: frequencyApi.listFrekansHatPresets,
    getFrekansHatPreset: frequencyApi.getFrekansHatPreset,
    createFrekansHatPreset: frequencyApi.createFrekansHatPreset,
    updateFrekansHatPreset: frequencyApi.updateFrekansHatPreset,
    deleteFrekansHatPreset: frequencyApi.deleteFrekansHatPreset,
    startNetworkRun: frequencyApi.startNetworkRun,
    getNetworkRun: frequencyApi.getNetworkRun,
    getNetworkRunHat: frequencyApi.getNetworkRunHat,
    stopNetworkRun: frequencyApi.stopNetworkRun,
    retryNetworkRun: frequencyApi.retryNetworkRun,
    listNetworkRuns: frequencyApi.listNetworkRuns,
    entegrasyonYap: fleetApi.entegrasyonYap,
    stopEntegrasyon: fleetApi.stopEntegrasyon,
    saveFleetPlan: fleetApi.saveFleetPlan,
    getFleetPlans: fleetApi.getFleetPlans,
    getFleetPlanDetail: fleetApi.getFleetPlanDetail,
    deleteFleetPlan: fleetApi.deleteFleetPlan,
    getFleetOptimizationParams: fleetApi.getFleetOptimizationParams,
    buildGtfs: gtfsApi.buildGtfs,
    buildGtfsFromJson: gtfsApi.buildGtfsFromJson,
    buildGtfsFromScenario: gtfsApi.buildGtfsFromScenario,
    listGtfsFeeds: gtfsApi.listGtfsFeeds,
    getGtfsFeed: gtfsApi.getGtfsFeed,
    saveGtfsFeed: gtfsApi.saveGtfsFeed,
    deleteGtfsFeed: gtfsApi.deleteGtfsFeed,
    validateGtfsCsvs: gtfsApi.validateGtfsCsvs,
    inspectGtfs: gtfsApi.inspectGtfs,
    loadGtfsTable: gtfsApi.loadGtfsTable,
    modifyGtfs: gtfsApi.modifyGtfs,
    getRouteDetails: gtfsApi.getRouteDetails,
    getStopDetails: gtfsApi.getStopDetails,
    queryGtfsStops: gtfsApi.queryGtfsStops,
    queryGtfsTrips: gtfsApi.queryGtfsTrips,
    getDistricts: routeApi.getDistricts,
    runClustering: routeApi.runClustering,
    optimizeRoute: routeApi.optimizeRoute,
    generateCorridor: routeApi.generateCorridor,
    getClusteringResults: routeApi.getClusteringResults,
    getClusteringCache: routeApi.getClusteringCache,
    getRouteResults: routeApi.getRouteResults,
    analyzeCompetition: competitionApi.analyzeCompetition,
    getLinePairDetail: competitionApi.getLinePairDetail,
    getWhatIfScenarios: competitionApi.getWhatIfScenarios,
    getStopComparison: competitionApi.getStopComparison,
    exportCompetitionCsv: competitionApi.exportCompetitionCsv,
    getAnalysisProgress: competitionApi.getAnalysisProgress,
    getCompetitionHealth: competitionApi.getCompetitionHealth,
    getOdLines: competitionApi.getOdLines,
    login: authApi.login,
    logout: authApi.logout,
    getCurrentUser: authApi.getCurrentUser,
    getTenantLicense: authApi.getTenantLicense,
    getTenantModules: authApi.getTenantModules,
};
export default appApi;
